module.exports = __webpack_public_path__ + "static/media/educator-banner.d1e8ca20.png";